import ApiConnector from '@/models/ApiConnector';
import ApiModel     from '@widesk-core/models/ApiModel';
import config       from '@/config';

export const codeConnector = new ApiConnector({
	baseURL: config.api_endpoint + `/code`,
});

export default class CodeServiceModel extends ApiModel {
	public static get connector() {
		return codeConnector;
	}

	public static serviceName = 'code';
	public static partitionName = 'jts';
}